import { formatDistanceToNow, FormatDistanceToNowOptions } from "date-fns";
import { enUS as enLocale } from "date-fns/locale/en-US";
import { fr as frLocale } from "date-fns/locale/fr";

interface DateFormatOptions extends FormatDistanceToNowOptions {
  languageOverride?: "en" | "fr";
}

export const convertDateToDistanceNow = (
  date: Date,
  options?: DateFormatOptions
) => {
  const utcDate = new Date(date);
  const language = options?.languageOverride || "fr";
  const locale = language === "en" ? enLocale : frLocale;

  const { languageOverride, ...dateFormatOptions } = options || {};

  const finalOptions: FormatDistanceToNowOptions = {
    addSuffix: true,
    locale,
    ...dateFormatOptions,
  };

  return formatDistanceToNow(utcDate, finalOptions);
};

export const convertDaysLeft = (date: Date) => {
  const utcDate = new Date(date);
  const today = new Date();
  const diffTime = utcDate.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const isToday = (date: Date): boolean => {
  const now = new Date();
  return (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  );
};

export const isYesterday = (date: Date): boolean => {
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
};

export const isThisWeek = (date: Date): boolean => {
  const now = new Date();
  return (
    now.getFullYear() === date.getFullYear() &&
    getWeekNumber(now) === getWeekNumber(date)
  );
};

export const getWeekNumber = (date: Date): number => {
  const tempDate = new Date(date.getTime());
  tempDate.setUTCHours(0, 0, 0, 0);
  tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
  const yearStart = new Date(tempDate.getFullYear(), 0, 1);
  return Math.ceil(
    ((tempDate.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
  );
};

export const isPreviousWeek = (date: Date): boolean => {
  const now = new Date();
  const currentWeek = getWeekNumber(now);
  const dateWeek = getWeekNumber(date);

  return (
    (date.getFullYear() === now.getFullYear() &&
      dateWeek === currentWeek - 1) ||
    (date.getFullYear() === now.getFullYear() - 1 &&
      dateWeek === 52 &&
      currentWeek === 1)
  );
};

export const isThisMonth = (date: Date): boolean => {
  const now = new Date();
  return (
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  );
};

export const isPreviousMonth = (date: Date): boolean => {
  const now = new Date();
  return (
    (date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() - 1) ||
    (date.getFullYear() === now.getFullYear() - 1 &&
      date.getMonth() === 11 &&
      now.getMonth() === 0)
  );
};
